<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-image-edit-control formControlName="productImage" [(ngModel)]="model.data.productImage">
                </wbo-image-edit-control>
            </fui-column>
            <fui-column>
                <wbo-image-edit-control formControlName="icon" [(ngModel)]="model.data.icon">
                </wbo-image-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
